export class WorkCaseNoteModel {
    id: number ;
    date: Date ;
    text: string ;
}
